import { render, staticRenderFns } from "./ImageManager.vue?vue&type=template&id=61851bb6&scoped=true&"
import script from "./ImageManager.vue?vue&type=script&lang=ts&"
export * from "./ImageManager.vue?vue&type=script&lang=ts&"
import style0 from "./ImageManager.vue?vue&type=style&index=0&id=61851bb6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61851bb6",
  null
  
)

export default component.exports